import { Loader } from "@googlemaps/js-api-loader";
import { i18n, mapLanguage } from '../i18n.js';
import { GOOGLE_MAPS_API_KEY } from '../config.js';

// モーダル用のシンプルなGoogleMapクラス
class ModalGoogleMap {
  #map;
  #dom = {};
  #marker = null;
  #infoWindow = null;

  // GoogleMap.jsと同じピンのSVGデータ
  static PIN_DATA = {
    default: `<svg width="19" height="32" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.37408 0.04C9.10408 0.04 8.84408 0.38 8.57408 0.4C8.30408 0.42 8.04408 0.46 7.78408 0.51C7.52408 0.56 7.15408 0.21 6.89408 0.28C6.63408 0.35 6.40408 0.58 6.15408 0.67C5.90408 0.76 5.56408 0.71 5.32408 0.82C5.08408 0.93 4.89408 1.2 4.65408 1.34C4.41408 1.48 4.30408 1.8 4.08408 1.95C3.86408 2.1 3.53408 2.13 3.32408 2.3C3.11408 2.47 2.90408 2.66 2.71408 2.85C2.52408 3.04 2.28408 3.21 2.11408 3.42C1.94408 3.63 1.79408 3.87 1.63408 4.09C1.47408 4.31 1.58408 4.7 1.45408 4.94C1.32408 5.18 0.874084 5.25 0.764084 5.5C0.654084 5.75 0.964084 6.16 0.864084 6.42C0.764084 6.68 0.644084 6.9 0.574084 7.16C0.504084 7.42 0.0540841 7.59 0.0140841 7.86C-0.0259159 8.13 0.0340841 8.42 0.0140841 8.69C-0.00591592 8.96 0.0440841 9.24 0.0440841 9.51C0.0440841 9.77 0.164084 10.02 0.184084 10.29C0.204084 10.56 0.344084 10.79 0.374084 11.06C0.404084 11.33 0.524084 11.55 0.574084 11.82C0.624084 12.09 0.684084 12.32 0.744084 12.58C0.804084 12.84 0.774084 13.1 0.834084 13.36C0.894084 13.62 0.944084 13.87 1.01408 14.12C1.08408 14.37 0.884084 14.7 0.964084 14.96C1.04408 15.22 1.20408 15.44 1.28408 15.69C1.36408 15.94 1.37408 16.21 1.46408 16.46C1.55408 16.71 1.63408 16.96 1.72408 17.2C1.81408 17.44 1.72408 17.77 1.81408 18.01C1.90408 18.25 2.45408 18.32 2.55408 18.57C2.65408 18.82 2.29408 19.25 2.39408 19.49C2.49408 19.73 2.75408 19.91 2.85408 20.16C2.95408 20.41 3.06408 20.65 3.16408 20.89C3.26408 21.13 3.51408 21.31 3.62408 21.55C3.73408 21.79 3.97408 21.97 4.08408 22.21C4.19408 22.45 4.45408 22.62 4.57408 22.85C4.69408 23.08 4.48408 23.48 4.60408 23.72C4.72408 23.96 4.65408 24.29 4.77408 24.52C4.89408 24.75 5.42408 24.78 5.54408 25.01C5.66408 25.24 5.36408 25.71 5.48408 25.93C5.60408 26.15 6.21408 26.14 6.33408 26.37C6.45408 26.6 6.49408 26.89 6.62408 27.11C6.75408 27.35 6.78408 27.63 6.91408 27.85C7.04408 28.09 7.39408 28.19 7.52408 28.41C7.66408 28.65 7.38408 29.11 7.51408 29.33C7.65408 29.57 7.87408 29.75 8.00408 29.96C8.15408 30.21 8.49408 30.31 8.62408 30.51C8.78408 30.77 8.54408 31.24 8.66408 31.42C8.95408 31.86 9.61408 31.91 9.61408 31.85C9.61408 31.91 9.53408 31.68 9.82408 31.24C9.94408 31.06 10.1341 30.86 10.2941 30.6C10.4241 30.4 10.6241 30.21 10.7741 29.97C10.9041 29.76 11.0741 29.56 11.2241 29.32C11.3541 29.1 11.5341 28.9 11.6641 28.66C11.7941 28.44 11.8741 28.19 12.0141 27.95C12.1441 27.73 12.3941 27.57 12.5241 27.33C12.6541 27.09 12.7041 26.83 12.8341 26.6C12.9641 26.37 12.9041 26.05 13.0341 25.81C13.1641 25.57 13.2741 25.34 13.3941 25.11C13.5141 24.88 13.8541 24.76 13.9741 24.52C14.0941 24.28 14.0841 23.99 14.2041 23.75C14.3241 23.51 14.2241 23.18 14.3441 22.94C14.4641 22.7 14.4741 22.42 14.5841 22.18C14.6941 21.94 15.1641 21.87 15.2741 21.63C15.3841 21.39 15.4041 21.11 15.5141 20.87C15.6241 20.63 15.6241 20.34 15.7341 20.1C15.8441 19.86 15.9741 19.63 16.0741 19.38C16.1741 19.13 16.3541 18.92 16.4541 18.68C16.5541 18.44 16.4541 18.11 16.5541 17.86C16.6541 17.61 17.1241 17.51 17.2141 17.26C17.3041 17.01 17.2741 16.71 17.3641 16.47C17.4541 16.23 17.1741 15.85 17.2541 15.6C17.3341 15.35 17.4941 15.12 17.5641 14.87C17.6341 14.62 17.6441 14.35 17.7141 14.09C17.7841 13.83 18.1241 13.65 18.1841 13.4C18.2441 13.15 18.4841 12.92 18.5341 12.66C18.5841 12.4 18.7241 12.15 18.7641 11.89C18.8041 11.63 18.5441 11.31 18.5741 11.05C18.6041 10.79 18.4541 10.51 18.4641 10.25C18.4841 9.98 18.4641 9.73 18.4641 9.48C18.4641 9.21 18.8241 8.92 18.8041 8.66C18.7841 8.4 18.4641 8.16 18.4141 7.89C18.3641 7.62 18.4741 7.32 18.4141 7.06C18.3541 6.8 18.3041 6.52 18.2041 6.27C18.1041 6.02 17.8141 5.85 17.7041 5.6C17.5941 5.35 17.5041 5.1 17.3741 4.87C17.2441 4.64 17.0941 4.41 16.9441 4.19C16.7941 3.97 16.6141 3.77 16.4441 3.56C16.2741 3.35 16.3641 2.89 16.1641 2.7C15.9641 2.51 15.5541 2.55 15.3441 2.38C15.1341 2.21 14.9041 2.07 14.6841 1.91C14.4641 1.75 14.4141 1.3 14.1841 1.17C13.9541 1.04 13.6541 0.97 13.4141 0.85C13.1741 0.73 12.7541 1.03 12.5041 0.94C12.2541 0.85 12.0541 0.6 11.7941 0.53C11.5341 0.46 11.3041 0.26 11.0341 0.21C10.7641 0.16 10.4541 0.53 10.1841 0.51C9.91408 0.49 9.67408 0 9.40408 0L9.37408 0.04Z" fill="#FF5B5B"/></svg>`,
  };

  constructor(el, lat, lng, municipalities = null, copy = null, eyecatch = null) {
    this.#dom.el = el;
    this.lat = parseFloat(lat);
    this.lng = parseFloat(lng);
    this.municipalities = municipalities;
    this.copy = copy;
    this.eyecatch = eyecatch;
    
    this.loader = new Loader({
      // apiKey: 'AIzaSyAZGVqmzFzOB3NTINBCuFLMv3X4vvB8GfE', // 開発用API
      apiKey: GOOGLE_MAPS_API_KEY, // 本番用（ローカルは .env の API で上書き）
      version: 'weekly',
      libraries: ['places'],
      language: mapLanguage, // 地図ラベルを表示言語に合わせる（GoogleMap.js と同じ値にすること）
    });

    this.mapOptions = {
      center: { lat: this.lat, lng: this.lng },
      zoom: 15,
      fullscreenControl: false,
      mapTypeControl: false,
      mapTypeId: 'satellite',
      mapId: 'DEMO_MAP_ID',
    };

    this.#init();
  }

  async #init() {
    try {
      await this.loader.load();
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
      this.AdvancedMarkerElement = AdvancedMarkerElement;

      this.#map = new google.maps.Map(this.#dom.el, this.mapOptions);
      
      // 提供されたスタイルJSONをStyledMapType形式に変換
      const customMapStyles = [
        // 都市域 - infrastructure.urbanArea → landscape.man_made
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.fill',
          stylers: [{ color: '#657b68' }, { visibility: 'on' }]
        },
        // 自然の土地被覆 - natural.land.landCover → landscape.natural
        {
          featureType: 'landscape.natural',
          elementType: 'geometry.fill',
          stylers: [{ color: '#6d9f5b' }, { visibility: 'on' }]
        },
        // 森林 - natural.land.landCover.forest → poi.park
        {
          featureType: 'poi.park',
          elementType: 'geometry.fill',
          stylers: [{ color: '#557a57' }, { visibility: 'on' }]
        },
        // 水域 - natural.water → water
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{ color: '#5dafab' }]
        },
        // POI全般を非表示 - pointOfInterest
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        // 個別POIカテゴリも明示的に非表示
        {
          featureType: 'poi.business',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.medical',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.place_of_worship',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.school',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.attraction',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        // 自然保護区 - pointOfInterest.recreation.natureReserve
        {
          featureType: 'poi.park',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#3e6365' }, { visibility: 'on' }]
        },
        // 政治的境界を非表示 - political
        {
          featureType: 'administrative',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        // 道路シールドを非表示 - infrastructure.roadNetwork.roadShield
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        },
        // 道路ラベルも調整
        {
          featureType: 'road.highway',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        }
      ];

      // カスタムスタイルを適用
      const styledMapType = new google.maps.StyledMapType(customMapStyles, {
        name: 'Aizu Custom Style'
      });
      
      this.#map.mapTypes.set('aizu_custom', styledMapType);
      this.#map.setMapTypeId('aizu_custom');
      
      // マップ読み込み完了後にピンを追加
      google.maps.event.addListenerOnce(this.#map, 'idle', () => {
        this.#createMarker();
      });
    } catch (e) {
      console.error("Google Maps API のロードに失敗しました:", e);
    }
  }

  // ピンを作成
  #createMarker() {
    const markerContent = document.createElement('div');
    markerContent.className = 'custom-pin';
    markerContent.innerHTML = ModalGoogleMap.PIN_DATA['default'];

    // マーカーを作成
    this.#marker = new this.AdvancedMarkerElement({
      position: { lat: this.lat, lng: this.lng },
      map: this.#map,
      content: markerContent,
      title: i18n('shootingSpot'),
      anchorLeft: '-50%',
      anchorTop: '-100%',
    });

    // InfoWindowを作成
    this.#createInfoWindow();

    // マーカークリック時にInfoWindowを表示
    this.#marker.addListener('click', () => {
      this.#infoWindow.open(this.#map, this.#marker);
    });

    // デフォルトでInfoWindowを表示
    setTimeout(() => {
      this.#infoWindow.open(this.#map, this.#marker);
    }, 500); // マーカーのアニメーション完了後に表示
  }

  // InfoWindowを作成
  #createInfoWindow() {
    // InfoWindowの内容を作成
    let content = '<div class="modal-info-window">';
    
    // eyecatch画像がある場合は表示
    if (this.eyecatch) {
      content += `<div class="modal-info-window__image">
        <span class="c-clip"><img src="${this.eyecatch}" width="180" height="180" alt="${i18n('shootingSpotImg')}" decoding="async" fetchpriority="high"></span>
      </div>`;
    }
    
    if (this.municipalities) {
      content += `<div class="modal-info-window__location">${this.municipalities}</div>`;
    }
    
    if (this.copy) {
      content += `<div class="modal-info-window__copy">${this.copy}</div>`;
    }
    
    if (!this.municipalities && !this.copy) {
      content += `<div class="modal-info-window__default">${i18n('shootingSpot')}</div>`;
    }
    
    content += '</div>';

    // InfoWindowを作成
    this.#infoWindow = new google.maps.InfoWindow({
      content: content,
      maxWidth: 300,
    });
  }
}

// 汎用的なYouTube動画モーダルクラス
class VideoModal {
  #dom = {};
  #isOpen = false;
  #googleMap = null;
  #movieSpots = [];
  #currentIndex = -1;

  constructor() {
    this.#createModal();
    this.#bindEvents();
  }

  // モーダルのHTML要素を作成
  #createModal() {
    const modalHtml = `
      <div class="c-video-modal" data-js="video-modal">
        <div class="c-video-modal__overlay" data-js="video-modal-overlay"></div>
        <button class="c-video-modal__close" data-js="video-modal-close"></button>
        <div class="c-video-modal__container">
          <div class="c-video-modal__map">
            <div class="c-video-modal__map-wrapper" data-js="video-modal-map-wrapper"></div>
          </div>
          <div class="c-video-modal__content">
            <div class="c-video-modal__iframe-wrapper">
              <iframe 
                class="c-video-modal__iframe" 
                data-js="video-modal-iframe"
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowfullscreen>
              </iframe>
            </div>
            <ul class="c-video-modal-navigation">
              <li class="c-video-modal-navigation-item">
                <button type="button" class="c-video-modal-navigation-item__button">
                  <span class="c-video-modal-navigation-item__arrow"></span>
                  <span class="c-video-modal-navigation-item__label">${i18n('prevMovie')}</span>
                </button>
              </li>
              <li class="c-video-modal-navigation-item">
                <button type="button" class="c-video-modal-navigation-item__button">
                  <span class="c-video-modal-navigation-item__label">${i18n('nextMovie')}</span>
                  <span class="c-video-modal-navigation-item__arrow"></span>
                </button>
              </li>
            </ul>
          </div>
          <div class="c-video-modal__group">
            <h2 class="c-video-modal-title">
              <span class="c-video-modal-title__area">下郷町</span>
              <span class="c-video-modal-title__label">宿場町としての誇り</span>
            </h2>
            <div class="c-video-modal__image"></div>
          </div>
        </div>
      </div>
    `;

    // bodyに追加
    document.body.insertAdjacentHTML('beforeend', modalHtml);

    // DOM要素を取得
    this.#dom.modal = document.querySelector('[data-js="video-modal"]');
    this.#dom.overlay = document.querySelector('[data-js="video-modal-overlay"]');
    this.#dom.closeButton = document.querySelector('[data-js="video-modal-close"]');
    this.#dom.iframe = document.querySelector('[data-js="video-modal-iframe"]');
    this.#dom.mapWrapper = document.querySelector('[data-js="video-modal-map-wrapper"]');
    this.#dom.titleArea = document.querySelector('.c-video-modal-title__area');
    this.#dom.titleLabel = document.querySelector('.c-video-modal-title__label');
    this.#dom.navigation = this.#dom.modal.querySelector('.c-video-modal-navigation');
  }

  // イベントリスナーを設定
  #bindEvents() {
    // オーバーレイクリックで閉じる
    this.#dom.overlay.addEventListener('click', () => {
      this.close();
    });

    // 閉じるボタンクリックで閉じる
    this.#dom.closeButton.addEventListener('click', () => {
      this.close();
    });

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.#isOpen) {
        this.close();
      }
    });

    // 次の動画ボタン
    const nextButton = this.#dom.modal.querySelector('.c-video-modal-navigation-item:nth-child(1) .c-video-modal-navigation-item__button');
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        this.#navigate('next');
      });
    }

    // 前の動画ボタン
    const prevButton = this.#dom.modal.querySelector('.c-video-modal-navigation-item:nth-child(2) .c-video-modal-navigation-item__button');
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        this.#navigate('prev');
      });
    }
  }

  // 動画のあるスポット一覧をロード
  #loadMovieSpots() {
    if (this.#movieSpots && this.#movieSpots.length > 0) return;

    this.#movieSpots = [];

    // 1. [data-js="locations"] があれば優先（Mapページ）
    const locationsEl = document.querySelector('[data-js="locations"]');
    if (locationsEl) {
      try {
        const rawData = JSON.parse(locationsEl.textContent);
        if (Array.isArray(rawData)) {
          this.#movieSpots = rawData.filter(spot => spot.contents === 'movie' || spot.movie);
        }
      } catch (e) {
        console.error('Failed to parse locations JSON in VideoModal', e);
      }
    }

    // 2. 空であればDOMから [data-js="modal-video"] ボタンを検索（Movieページ）
    if (this.#movieSpots.length === 0) {
      const videoButtons = document.querySelectorAll('[data-js="modal-video"]');
      if (videoButtons.length > 0) {
        this.#movieSpots = Array.from(videoButtons).map(button => ({
          movie: button.dataset.id,
          position: {
            lat: button.dataset.lat ? parseFloat(button.dataset.lat) : null,
            lng: button.dataset.lng ? parseFloat(button.dataset.lng) : null
          },
          municipalities: button.dataset.municipalities,
          copy: button.dataset.copy,
          thumbnail: button.dataset.eyecatch
        })).filter(spot => spot.movie);
      }
    }
  }

  // モーダルのナビゲーション表示切り替え
  #updateNavigationVisibility() {
    if (this.#dom.navigation) {
      if (this.#movieSpots && this.#movieSpots.length > 1) {
        this.#dom.navigation.style.display = '';
      } else {
        this.#dom.navigation.style.display = 'none';
      }
    }
  }

  // 前後の動画へ切り替え
  #navigate(direction) {
    if (!this.#movieSpots || this.#movieSpots.length <= 1) return;

    if (direction === 'next') {
      this.#currentIndex = (this.#currentIndex - 1 + this.#movieSpots.length) % this.#movieSpots.length;
    } else if (direction === 'prev') {
      this.#currentIndex = (this.#currentIndex + 1) % this.#movieSpots.length;
    }

    const nextSpot = this.#movieSpots[this.#currentIndex];
    if (nextSpot) {
      const videoId = nextSpot.movie;
      const lat = nextSpot.position ? nextSpot.position.lat : null;
      const lng = nextSpot.position ? nextSpot.position.lng : null;
      const municipalities = nextSpot.municipalities || null;
      const copy = nextSpot.copy || null;
      const eyecatch = nextSpot.thumbnail || null;

      this.#updateModalContent(videoId, lat, lng, municipalities, copy, eyecatch);
    }
  }

  // モーダルの表示コンテンツを更新
  #updateModalContent(videoId, lat, lng, municipalities, copy, eyecatch) {
    if (!videoId) return;

    // iframeのsrcを設定
    const videoUrl = this.#generateYouTubeUrl(videoId);
    if (this.#dom.iframe.contentWindow) {
      this.#dom.iframe.contentWindow.location.replace(videoUrl);
    } else {
      this.#dom.iframe.src = videoUrl;
    }

    // タイトル情報を更新
    if (this.#dom.titleArea) {
      this.#dom.titleArea.textContent = municipalities || '';
    }
    if (this.#dom.titleLabel) {
      this.#dom.titleLabel.textContent = copy || '';
    }

    // GoogleMapを初期化（緯度経度が提供されている場合）
    if (lat && lng) {
      this.#initializeMap(lat, lng, municipalities, copy, eyecatch);
    } else {
      // 緯度経度がない場合はマップを非表示にする、あるいはクリア
      if (this.#googleMap) {
        this.#dom.mapWrapper.innerHTML = '';
        this.#googleMap = null;
      }
    }
  }

  // YouTube動画IDからURLを生成
  #generateYouTubeUrl(videoId, autoplay = true) {
    const baseUrl = 'https://www.youtube.com/embed/';
    const params = new URLSearchParams({
      autoplay: autoplay ? '1' : '0',
      rel: '0', // 関連動画を表示しない
      modestbranding: '1', // YouTubeロゴを控えめに
      playsinline: '1' // iOSでインライン再生
    });
    
    return `${baseUrl}${videoId}?${params.toString()}`;
  }

  // GoogleMapを初期化
  #initializeMap(lat, lng, municipalities = null, copy = null, eyecatch = null) {
    if (!lat || !lng) {
      console.warn('緯度経度が指定されていません');
      return;
    }

    // 既存のマップがあれば削除
    if (this.#googleMap) {
      this.#dom.mapWrapper.innerHTML = '';
      this.#googleMap = null;
    }

    // マップ用のdiv要素を作成
    const mapDiv = document.createElement('div');
    mapDiv.style.width = '100%';
    mapDiv.style.height = '100%';
    mapDiv.dataset.path = '../../'; // パスを設定
    this.#dom.mapWrapper.appendChild(mapDiv);

    // モーダル用のGoogleMapインスタンスを作成（指定座標を中心に、municipalities、copy、eyecatch を渡す）
    this.#googleMap = new ModalGoogleMap(mapDiv, lat, lng, municipalities, copy, eyecatch);
  }

  // モーダルを開く
  open(videoId, lat = null, lng = null, municipalities = null, copy = null, eyecatch = null) {
    if (!videoId) {
      console.warn('Video ID is required to open video modal');
      return;
    }

    // 全データから動画スポットをロード
    this.#loadMovieSpots();

    // 現在のインデックスを特定
    this.#currentIndex = this.#movieSpots.findIndex(spot => spot.movie === videoId);
    
    // もしリストに見つからない場合は、現在渡された情報から一時的にスポット情報を構築してリストに入れる
    if (this.#currentIndex === -1) {
      const tempSpot = {
        movie: videoId,
        position: { lat: lat ? parseFloat(lat) : null, lng: lng ? parseFloat(lng) : null },
        municipalities: municipalities,
        copy: copy,
        thumbnail: eyecatch
      };
      this.#movieSpots.push(tempSpot);
      this.#currentIndex = this.#movieSpots.length - 1;
    }

    // コンテンツを更新
    this.#updateModalContent(videoId, lat, lng, municipalities, copy, eyecatch);

    // ナビゲーションボタンの表示切り替え
    this.#updateNavigationVisibility();

    // モーダルを表示
    this.#dom.modal.classList.add('is-open');
    this.#isOpen = true;

    // bodyのスクロールを無効化
    document.body.style.overflow = 'hidden';
  }

  // モーダルを閉じる
  close() {
    // モーダルを非表示
    this.#dom.modal.classList.remove('is-open');
    this.#isOpen = false;

    // iframeのsrcをクリア（動画停止）
    if (this.#dom.iframe.contentWindow) {
      this.#dom.iframe.contentWindow.location.replace('about:blank');
    } else {
      this.#dom.iframe.src = '';
    }

    // マップをクリア
    if (this.#googleMap) {
      this.#dom.mapWrapper.innerHTML = '';
      this.#googleMap = null;
    }

    // 動画リストとインデックスをリセット
    this.#movieSpots = [];
    this.#currentIndex = -1;

    // bodyのスクロールを有効化
    document.body.style.overflow = '';
  }

  // モーダルが開いているかどうかを取得
  isOpen() {
    return this.#isOpen;
  }
}

export default VideoModal;
